/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

const ExportStoreStatus = {
  edit: {
    name: 'แก้ไขข้อมูล',
    color: 'warning',
    icon: 'border_color',
  },
  check: {
    name: 'ส่งตรวจสอบ',
    color: 'info',
    icon: 'task_outlined',
  },
  reject: {
    name: 'ตรวจไม่ผ่าน',
    color: 'error',
    icon: 'highlight_off_outlined',
  },
  ready: {
    name: 'พร้อมจัดส่ง',
    color: 'info',
    icon: 'shopping_basket',
  },
  liftcar: {
    name: 'ยกขึ้นรถ',
    color: 'info',
    icon: 'sign_language',
  },
  transport: {
    name: 'จัดส่ง',
    color: 'info',
    icon: 'local_shipping',
  },
  receive: {
    name: 'รับบางส่วน',
    color: 'info',
    icon: 'rule_outlined',
  },
  success: {
    name: 'เสร็จสิ้น',
    color: 'success',
    icon: 'task_alt',
  },
  cancel: {
    name: 'ยกเลิก',
    color: 'error',
    icon: 'cancel',
  },
};

export default ExportStoreStatus;
